import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Api from '../../component/Api';

import Template from '../../component/Template.js';
import { ToastContainer, toast } from 'react-toastify';

const AdminChangePassword = () => {

  const navigate = useNavigate();
  const { http } = Api();

  const [newPassword, setNewPassword] = useState('');
  const [retypePassword, setRetypePassword] = useState('');
  const [error, setError] = useState('');
  const [userID, setUserID] = useState('');
  const [validationRegMessage, setValidationRegMessage] = useState({});
  const [isRedirecting, setIsRedirecting] = useState(false);
  const [regError, setRegerror] = useState('');
  const [success, setSuccess] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConPassword, setShowConPassword] = useState(false);


  const validateForm = () => {
    const setErrors = {};

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!userID) {
      setErrors.general = '*Please enter User ID';
    }
    const passwordRegex = /^(?=.*[A-Z])(?=.*[!@#$%^&*])(?=.{8,})/;

    if (!newPassword && !retypePassword) {
      setErrors.general = '*Please enter all required fields';
    }


    if (!passwordRegex.test(newPassword)) {
      setErrors.newPassword = '*Password must be at least 8 characters long, include one capital and special character';
    }
    // Validate if new password and retype password are the same
    if (newPassword !== retypePassword) {
      setErrors.retypePassword = '*Passwords do not match';
    }
    setValidationRegMessage(setErrors);
    return Object.keys(setErrors).length === 0;

  };


  //register

  const handleSubmit = (e) => {
    e.preventDefault();
    setValidationRegMessage('');
    setRegerror('');
    setSuccess('');

    if (validateForm()) {
      setIsRedirecting(true); // Set redirecting to true before making the API call

      http.post('College/updatePassword', {
        email: userID,
        password: newPassword,
        password_confirmation: retypePassword
      })
        .then(response => {
          // console.log("Response:", response);
          if (response.data.status_code === "MSG2") {
            setRegerror('');
            toast.success(response.data.message);
            setTimeout(() => {
              navigate('/admin/dashboard');
            }, 3000);

          }
       
          else {
            setRegerror(response.data.message);
            toast.error(response.data.message)
          }
        })
        .catch(error => {
          // console.log("error", error);
          if (error.response.data.status_code === 'ERR1' || error.response.data.http_status === 422) {
            const passwordErrors = error.response.data.data.errors.password.join(', ');
            toast.error(passwordErrors);
            setRegerror(error.response.data.data.errors.password.join(', '));

          } 
          else if(error.response.data.status_code === "ERR8" || error.response.data.http_status	=== 401) {
            toast.error("Invalid User ID");

          }
          else {
            const errorMessage = error.response?.data?.message || 'An error occurred';
            toast.error(errorMessage);
          }

          setRegerror(error.response?.data?.message || 'An error occurred');
        })
        .finally(() => {
          setIsRedirecting(false);
          setUserID('');
          setNewPassword('');
          setRetypePassword('');
        });
    }
    else {
      toast.error("Please correct the highlighted errors.");
    }
  };

  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };
  const toggleShowConPassword = () => {
    setShowConPassword(!showConPassword);
  };

  return (
    <>

      <ToastContainer />
      <Template>
        <div className="container-fluid d-flex justify-content-center mt-auto min-vh-100">
          <div className="col-xl-8">
            <div className="card">
              <div className="card-body">
                <div className="login-main">
                  <form className="theme-form" onSubmit={handleSubmit}>
                    <h4>Create/Change MGU-UGP Password</h4>
                    <div className="form-group">
                      <label className="col-form-label">Existing User ID</label>
                      <div className="form-input position-relative">
                        <input
                          className="form-control"
                          type="text"
                          value={userID}
                          onChange={(e) => setUserID(e.target.value)}

                          placeholder="Existing User ID"
                        />

                      </div>
                    </div>
                    <div className="form-group">
                      <label className="col-form-label">New Password<span className="text-danger">*</span></label>
                      <div className="form-input position-relative">
                        <input
                          className="form-control"
                          type={showPassword ? "text" : "password"}
                          value={newPassword}
                          onChange={(e) => setNewPassword(e.target.value)}

                          placeholder="*********"
                        />
                        <span
                          className="password-toggle e-icon"
                          onClick={toggleShowPassword}
                        >
                          <i className={`fa ${showPassword ? "fa-eye fa-stl" : "fa-eye-slash fa-stl"}`} />
                        </span>

                      </div>
                    </div>
                    <div className="form-group">
                      <label className="col-form-label">Retype Password<span className="text-danger">*</span></label>
                      <div className="form-input position-relative">
                        <input
                          className="form-control"
                          type={showConPassword ? "text" : "password"}
                          value={retypePassword}
                          onChange={(e) => setRetypePassword(e.target.value)}
                          placeholder="*********"
                        />
                        <span
                          className="password-toggle e-icon"
                          onClick={toggleShowConPassword}
                        >
                          <i className={`fa ${showConPassword ? "fa-eye fa-stl" : "fa-eye-slash fa-stl"}`} />
                        </span>

                      </div>
                    </div>


                    <div>

                      {validationRegMessage.general && (
                        <span className="validation-message">
                          {validationRegMessage.general}
                        </span>
                      )}
                      {validationRegMessage.emailId && (
                        <span className="validation-message">
                          {validationRegMessage.emailId}
                        </span>
                      )}
                      {validationRegMessage.newPassword && (
                        <p className="text-danger">{validationRegMessage.newPassword}</p>
                      )}
                      {validationRegMessage.retypePassword && (
                        <p className="text-danger">{validationRegMessage.retypePassword}</p>
                      )}
                      {regError && (
                        <span className="validation-message">
                          {regError}
                        </span>
                      )}

                      {success && (
                        <span className="success-message">
                          {success}
                        </span>
                      )}
                    </div>

                    {error && <p className="text-danger">{error}</p>}
                    <div className="form-group mb-0 mt-1">
                      <button className="btn btn-primary btn-block w-100" type="submit">Done</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Template>

    </>
  );
};

export default AdminChangePassword;
